// Colors matching the existing design system
export const categoryColors = {
  shuttleStop: "#9ccccb", // seersucker blue — all shuttle stops use this color
  ceremony:    "#00233f", // navy blue
  reception:   "#87b249", // green
  hotel:       "#f680a3", // pink
  other:       "#f680a3", // pink
};

export const categoryLabels = {
  shuttleStop: "Shuttle Stop",
  ceremony:    "Church",
  reception:   "Reception",
  hotel:       "Hotel",
  other:       "Point of Interest",
};

// ---------------------------------------------------------------------------
// Shuttle stops — all guests assigned to a shuttle will be routed here.
// coordinates: [longitude, latitude]
// shuttle: must match the shuttle name stored in the Firebase reservation doc
// ---------------------------------------------------------------------------
export const shuttleStops = [
  {
    id: "stop-1",
    name: "Marshall Slocum Inn",
    address: "29 Kay St, Newport, RI 02840",
    coordinates: [-71.30787, 41.48997],
    shuttle: "Shuttle A",
    pickupTime: "1:15 PM",
  },
  {
    id: "stop-2",
    name: "Wellington Ave & Thames St",
    address: "Wellington Ave & Thames St, Newport, RI 02840",
    coordinates: [-71.314056, 41.476943],
    shuttle: "Shuttle B",
    pickupTime: "1:15 PM",
  },
  {
    id: "stop-3",
    name: "Perrotti Park",
    address: "America's Cup Ave, Newport, RI 02840",
    coordinates: [-71.316872, 41.489594],
    shuttle: "Shuttle C",
    pickupTime: "1:10 PM",
  },
  {
    id: "stop-4",
    name: "Newport Marriott",
    address: "25 America's Cup Ave, Newport, RI 02840",
    coordinates: [-71.318188, 41.490039],
    shuttle: "Shuttle D",
    pickupTime: "1:00 PM",
  },
  {
    id: "stop-5a",
    name: "Sonesta Select Newport",
    address: "9 Commerce Dr, Middletown, RI 02842",
    coordinates: [-71.298749, 41.529221],
    shuttle: "Shuttle E",
    pickupTime: "1:10 PM",
  },
  {
    id: "stop-5b",
    name: "The Pell",
    address: "425 E Main Rd, Middletown, RI 02842",
    coordinates: [-71.285779, 41.520584],
    shuttle: "Shuttle E",
    pickupTime: "1:10 PM",
  },
  {
    id: "stop-6a",
    name: "Residence Inn",
    address: "325 West Main Rd, Middletown, RI 02842",
    coordinates: [-71.299131, 41.514275],
    shuttle: "Shuttle F",
    pickupTime: "1:05 PM",
  },
  {
    id: "stop-6b",
    name: "Rodeway Inn",
    address: "31 West Main Rd, Middletown, RI 02842",
    coordinates: [-71.301147, 41.506514],
    shuttle: "Shuttle F",
    pickupTime: "1:05 PM",
  },
  {
    id: "stop-6c",
    name: "Wayfinder",
    address: "151 Admiral Kalbfus Rd, Newport, RI 02840",
    coordinates: [-71.312638, 41.508829],
    shuttle: "Shuttle F",
    pickupTime: "1:05 PM",
  },
  {
    id: "stop-7",
    name: "49 Maple Ave",
    address: "49 Maple Ave, Middletown, RI 02842",
    coordinates: [-71.3028, 41.51644],
    shuttle: "Shuttle G",
    pickupTime: "1:05 PM",
  },
];

// ---------------------------------------------------------------------------
// Places of interest — shown on the map in category-specific colors.
// category must be one of the keys in categoryColors (except "shuttleStop").
// ---------------------------------------------------------------------------
export const placesOfInterest = [
  {
    id: "poi-ceremony",
    name: "St. Mary's Church",
    address: "12 William St, Newport, RI 02840",
    coordinates: [-71.312381, 41.483829],
    category: "ceremony",
  },
  {
    id: "poi-reception",
    name: "Castle Hill Inn",
    address: "590 Ocean Dr, Newport, RI 02840",
    coordinates: [-71.360779, 41.464029],
    category: "reception",
  },
  // {
  //   id: "poi-hotel-1",
  //   name: "Hotel Block 1",
  //   address: "100 Bellevue Ave, Newport, RI 02840",
  //   coordinates: [-71.3128, 41.4901],
  //   category: "hotel",
  // },
];
